export const admissionCapacityAchieved = ({
  maxCapacity,
  soldItems,
}: {
  maxCapacity: number | null;
  soldItems: number;
}) => {
  return !!maxCapacity && soldItems !== 0 && maxCapacity <= soldItems;
};
